export const checkTouchDevice = () => {
  return window.ontouchstart !== undefined;
};

export const capitalize = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase().replace(/_/g, ' ');
};

export const upperCase = (word: string) => {
  return word.toUpperCase().replace(/ /g, '_');
};

export const unitePascalCase = (text: string) => {
  return text
    .split('_')
    .map((word) => capitalize(word))
    .join('');
};

export const getCountryFlag = (country: string) => {
  const upperCaseCountry = country.toUpperCase();

  switch (upperCaseCountry) {
    case 'SE':
    case 'SV':
      return '🇸🇪';
    case 'NO':
      return '🇳🇴';
    case 'ES':
      return '🇪🇸';
    case 'TR':
      return '🇹🇷';
    case 'DK':
      return '🇩🇰';
    case 'GB':
    case 'EN':
      return '🇬🇧';
    case 'AE':
      return '🇦🇪';
    default:
      return '';
  }
};
